import inlineSvg from '@/script/inlineSvg.mjs'
import createShape from '../createShape.mjs'

export default () => {
    const extensions = map => ({
        getNodeBoxStyle(node) {
            return {}
        },

        getNodeLineStyle(node) {
            return {
                leadingLineColor: '#666',
                leadingLineWidth: 2,
                trailingLineColor: '#666',
                trailingLineWidth: 2,
            }
        },

        getNodeShape(node, textRect) {
            const style = this.getNodeShapeStyle(node)
            const paddings = new Array(4).fill(style.borderWidth)

            const draw = (w, h) => `
                <rect
                    x="${style.borderWidth / 2}"
                    y="${style.borderWidth / 2}"
                    width="${w - style.borderWidth}"
                    height="${h - style.borderWidth}"
                />
            `

            const shape = createShape(draw, textRect, paddings, style)
            return [shape, paddings]
        },

        getNodeShapeStyle(node) {
            return {
                borderWidth: 1,
                backgroundColor: '#eee',
                borderColor: '#333',
            }
        },

        getNodeTextStyle(node) {
            return {}
        },

        useNodeBackground(node) {
            map.useNodeChange(node.parent, ['children'])

            map.useNodeChange(node, [
                'children',
                'nextSibling',
                'parent',
                'prevSibling',
            ])

            const lines = []
            const styleNode = map.useNodeLineStyle(node)
            const styleParent = map.useNodeLineStyle(node.parent)

            if (node.parent) {
                lines.push(`
                    <line
                        x1="0"
                        x2="50%"
                        y1="50%"
                        y2="50%"
                        stroke="${styleNode.leadingLineColor}"
                        stroke-width="${styleNode.leadingLineWidth}"
                    />
                `)

                {
                    let cursor = node.prevSibling

                    while (cursor) {
                        const isHidden = map.isNodeHidden(cursor)

                        if (! isHidden) {
                            lines.push(`
                                <line
                                    x1="${styleParent.trailingLineWidth / 2}"
                                    x2="${styleParent.trailingLineWidth / 2}"
                                    y1="0"
                                    y2="50%"
                                    stroke="${styleParent.trailingLineColor}"
                                    stroke-width="${styleParent.trailingLineWidth}"
                                />
                            `)

                            break
                        }

                        cursor = cursor.prevSibling
                    }
                }

                {
                    let cursor = node.nextSibling

                    while (cursor) {
                        const isHidden = map.isNodeHidden(cursor)

                        if (! isHidden) {
                            lines.push(`
                                <line
                                    x1="${styleParent.trailingLineWidth / 2}"
                                    x2="${styleParent.trailingLineWidth / 2}"
                                    y1="50%"
                                    y2="100%"
                                    stroke="${styleParent.trailingLineColor}"
                                    stroke-width="${styleParent.trailingLineWidth}"
                                />
                            `)

                            break
                        }

                        cursor = cursor.nextSibling
                    }
                }
            }

            const hasChildren = [...map.children(node)].some(
                n => ! map.isNodeHidden(n)
            )

            if (hasChildren) {
                lines.push(`
                    <line
                        x1="50%"
                        x2="100%"
                        y1="50%"
                        y2="50%"
                        stroke="${styleNode.trailingLineColor}"
                        stroke-width="${styleNode.trailingLineWidth}"
                    />
                `)
            }

            return inlineSvg(`
                <svg xmlns="http://www.w3.org/2000/svg">
                    ${lines.join('\n')}
                </svg>
            `)
        },

        useNodeBoxStyle(node) {
            return node ? this.getNodeBoxStyle(node) : {}
        },

        useNodeLineStyle(node) {
            return node ? this.getNodeLineStyle(node) : {}
        },

        useNodeShape(node, textRect) {
            return node ? this.getNodeShape(node, textRect) : {}
        },

        useNodeShapeStyle(node) {
            return node ? this.getNodeShapeStyle(node) : {}
        },

        useNodeTextStyle(node) {
            return node ? this.getNodeTextStyle(node) : {}
        },
    })

    return {extensions}
}
